// import { createMuiTheme } from '@material-ui/core/styles';
// import COLORS from '../utils/constants/colors';
// import * as locale from '@material-ui/core/locale';
// import { getUserSelectedLanguage } from 'reducers/users';
// import { useEffect, useState } from 'react';
// import { useSelector } from 'react-redux';

// export const useMuiTheme = () => {
//   const [data, setData] = useState(null);
//   const getSelectedLanguage = useSelector(state =>
//     getUserSelectedLanguage(state),
//   );

//   const localeMap = {
//     en: locale.enUS,
//     id: locale.idID,
//     vn: locale.viVN,
//   };

//   const muiPreferedLanguage = () => localeMap[getSelectedLanguage];

//   useEffect(() => {
//     setData(
//       createMuiTheme(
//         {
//           typography: {
//             fontFamily: "'Source Sans Pro', sans-serif",
//           },
//           overrides: {
//             MuiIconButton: {
//               disabled: {},
//               root: {
//                 '&$disabled': {
//                   '& .MuiSvgIcon-root': {
//                     opacity: '0.2',
//                   },
//                 },
//               },
//             },
//             MuiSvgIcon: {
//               root: {
//                 color: 'white',
//                 overflow: 'visible',
//               },
//               fontSizeSmall: {
//                 fontSize: '1rem',
//               },
//               fontSizeInherit: {
//                 fontSize: '2rem',
//               },
//             },
//             MuiPaper: {
//               root: {
//                 margin: 0,
//                 fontWeight: 600,
//                 backgroundColor: '#413892',
//                 color: '#9f9bc8',
//               },
//             },
//             MuiInputLabel: {
//               formControl: {
//                 position: 'relative',
//                 transform: 'none',
//                 '& + .MuiInputBase-formControl': {
//                   marginTop: '10px',
//                 },
//               },
//             },
//             MuiAutocomplete: {
//               root: {
//                 '&:hover': {
//                   '& $clearIndicatorDirty': {
//                     display: 'inline-flex',
//                     visibility: 'visible',
//                   },
//                 },
//                 '& [class*="MuiInputBase-root"][class*="MuiInputBase-adornedEnd"]': {
//                   '&$inputRoot': {
//                     paddingRight: 31,
//                     '& $input': {
//                       '&:first-child': {
//                         padding: 4,
//                       },
//                     },
//                   },
//                 },

//                 '&[aria-expanded="true"]': {
//                   '& $endAdornment': {
//                     backgroundColor: '#222323',
//                   },
//                   '& $inputRoot': {
//                     backgroundColor: 'white',
//                     color: '#333',
//                   },
//                 },
//               },
//               groupLabel: {
//                 backgroundColor: COLORS.DARK_GREY_01,
//                 color: 'rgba(255,255,255, 0.5)',
//                 fontWeight: 'bold',
//               },
//               clearIndicatorDirty: {},
//               inputRoot: {
//                 width: '100%',
//                 color: 'white',
//                 padding: '0 10px',
//                 border: '1px solid #525355',
//                 borderRadius: 5,
//                 position: 'relative',
//                 background: '#3a3b3b',
//                 paddingBottom: '0px',

//                 '&[class*="MuiInputBase-adornedEnd"]': {
//                   paddingRight: 31,
//                 },
//               },
//               clearIndicator: {
//                 padding: 2,
//                 display: 'none',
//               },
//               input: {
//                 padding: 4,
//               },
//               endAdornment: {
//                 top: 0,
//                 background: '#333333',
//                 borderTopRightRadius: 5,
//                 height: '100%',
//                 borderBottomRightRadius: 5,
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 padding: 2,
//                 borderLeft: '1px solid #525355',
//               },
//               popper: {
//                 minWidth: 280,
//               },
//               paper: {
//                 borderRadius: 0,
//                 background: '#333',
//                 color: 'white',
//                 border: '1px solid #525355',
//                 margin: 1,
//               },
//               option: {
//                 '&[aria-selected="true"]': {
//                   backgroundColor: '#413892',
//                 },
//                 '&[data-focus="true"]': {
//                   backgroundColor: '#58595b',
//                 },
//                 '&:hover': {
//                   backgroundColor: '#58595b',
//                 },
//                 '&[aria-selected="true"]&[data-focus="true"]': {
//                   backgroundColor: '#413892',
//                 },
//               },
//               noOptions: {
//                 color: 'white',
//               },
//             },
//           },
//           props: {
//             MuiButtonBase: {
//               disableRipple: true,
//               disableTouchRipple: true,
//             },
//           },
//         },
//         muiPreferedLanguage(),
//       ),
//     );
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [getSelectedLanguage]);
//   return data;
// };
import COLORS from '../utils/constants/colors';
import { createTheme } from '@material-ui/core/styles';

const spaceValue = createTheme({
  spacing: 7,
});

const baseTheme = createTheme({
  props: {
    MuiPaper: {
      elevation: 0,
    },
    MuiAppBar: {
      elevation: 2,
    },
    MuiButton: {
      elevation: 0,
      disableElevation: true,
      disableRipple: true,
    },
    MuiMenu: {
      elevation: 2,
    },
    MuiCard: {
      elevation: 2,
    },
    props: {
      MuiButtonBase: {
        disableRipple: true,
        disableTouchRipple: true,
      },
    },
  },
  overrides: {
    MuiButton: {
      root: {
        minWidth: 0,
      },
      contained: {
        boxShadow: 'none',
        '&:active': {
          boxShadow: 'none',
        },
        '&:focus': {
          boxShadow: 'none',
        },
      },
    },
    MuiIconButton: {
      disabled: {},
      root: {
        '&$disabled': {
          '& .MuiSvgIcon-root': {
            opacity: '0.2',
          },
        },
      },
    },
    MuiSvgIcon: {
      fontSizeSmall: {
        // fontSize: '1rem',
      },
      fontSizeInherit: {
        // fontSize: '2rem',
      },
    },
    MuiPaper: {
      root: {
        margin: 0,
        // fontWeight: 600,
        // color: '#9f9bc8',
      },
    },
    MuiInputLabel: {
      root: {
        display: 'flex',
      },
      formControl: {
        position: 'relative',
        transform: 'none',
        '& + .MuiInputBase-formControl': {
          marginTop: '0',
        },
      },
    },
    MuiAutocomplete: {
      root: {
        '&:hover': {
          '& $clearIndicatorDirty': {
            display: 'inline-flex',
            visibility: 'visible',
          },
        },
        '& [class*="MuiInputBase-root"][class*="MuiInputBase-adornedEnd"]': {
          '&$inputRoot': {
            // paddingRight: 31,
            '& $input': {
              '&:first-child': {
                // padding: 4,
              },
            },
          },
        },
        '&[aria-expanded="true"]': {
          '& $endAdornment': {
            // backgroundColor: '#222323',
          },
          '& $inputRoot': {
            // backgroundColor: 'white',
            // color: '#333',
          },
        },
      },
      groupLabel: {
        fontWeight: 'bold',
      },
      clearIndicatorDirty: {},
      inputRoot: {
        width: '100%',
        // color: 'black',
        padding: '0 10px',
        // border: '1px solid #525355',
        position: 'relative',
        // background: '#3a3b3b',
        paddingBottom: '0px',
        '&[class*="MuiInputBase-adornedEnd"]': {
          paddingRight: 31,
        },
      },
      clearIndicator: {
        padding: 2,
        display: 'none',
      },
      input: {
        padding: 4,
      },
      endAdornment: {
        top: 0,
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // padding: 2,
        // backgroundColor: '#222323',
      },
      popper: {
        minWidth: 250,
      },
      paper: {
        borderRadius: 0,
        margin: 1,
      },
      option: {
        '&[aria-selected="true"]': {
          // backgroundColor: '#413892',
        },
        '&[data-focus="true"]': {
          // backgroundColor: '#58595b',
        },
        '&:hover': {
          // backgroundColor: '#58595b',
        },
        '&[aria-selected="true"]&[data-focus="true"]': {
          // backgroundColor: '#413892',
        },
      },
      noOptions: {
        color: COLORS.WHITE,
      },
    },
  },
  palette: {
    secondary: {
      main: COLORS.WHITE, //indigo[600],
    },
    primary: {
      main: COLORS.DARK_GREY_01, //'#619f30',
    },
    error: {
      main: COLORS.RED,
    },
    warning: {
      main: COLORS.ORANGE,
    },
    success: {
      main: COLORS.BLUE_01,
      highlight: COLORS.BLUE,
    },
    severity: {
      low: COLORS.GREEN,
      medium: COLORS.ORANGE,
      high: COLORS.RED,
      notrated: COLORS.BLUE_01,
    },
  },
  typography: {
    h1: {
      fontSize: '2rem',
    },
    h2: {
      fontSize: '1.8rem',
    },
    h3: {
      fontSize: '1.6rem',
    },
    h4: {
      fontSize: '1.4rem',
    },
    h5: {
      fontSize: '1.2rem',
    },
    h6: {
      fontSize: '1rem',
    },

    fontFamily: "'Source Sans Pro', sans-serif",
  },
  sidebar: {
    width: 255,
    widthCollapsed: spaceValue.spacing(8),
  },
  headerNotifications: {
    marginRight: 25,
  },
});

const theme = {
  ...baseTheme,
};

export default theme;
